export const LOADER_EVALUATION_FACTOR         =       'LOADER_EVALUATION_FACTOR';
export const GET_EVALUATION_FACTOR            =       'GET_EVALUATION_FACTOR';
export const GET_EVALUATION_FACTOR_ALL            =       'GET_EVALUATION_FACTOR_ALL';
export const EVALUATION_FACTOR_FALLA          =       'EVALUATION_FACTOR_FALLA';
export const SAVE_LOADER_EVALUATION_FACTOR    =       'SAVE_LOADER_EVALUATION_FACTOR';
export const FORM_EVALUATION_FACTOR_FAIL      =       'FORM_EVALUATION_FACTOR_FAIL';

